import { fr } from "@codegouvfr/react-dsfr";
import { Loader } from "react-design-system";
import { Feedback } from "src/app/components/feedback/Feedback";
import { RequestRegisterEstablishmentsForUserForm } from "src/app/components/forms/register-establishments/RequestRegisterEstablishmentsForUserForm";
import { useAppSelector } from "src/app/hooks/reduxHooks";
import { connectedUserSelectors } from "src/core-logic/domain/connected-user/connectedUser.selectors";

export const EstablishmentUserRegistrationPage = () => {
  const currentUser = useAppSelector(connectedUserSelectors.currentUser);
  const isLoading = useAppSelector(connectedUserSelectors.isLoading);
  if (isLoading) {
    return <Loader />;
  }
  if (!currentUser)
    return <p>Merci de vous connecter pour accéder à cette page.</p>;
  return (
    <>
      <h1>Se rattacher à une entreprise</h1>
      <p>
        Bonjour {currentUser.firstName} {currentUser.lastName}, recherchez une
        entreprise afin d'accéder aux offres et mises en relation de cette
        dernière. Un administrateur vérifiera et validera votre demande.
      </p>
      <Feedback
        topics={["establishment-user-registration"]}
        closable
        className={fr.cx("fr-mb-2w")}
      />
      <RequestRegisterEstablishmentsForUserForm currentUser={currentUser} />
    </>
  );
};
